import script from "./Message.vue?vue&type=script&lang=ts&setup=true"
export * from "./Message.vue?vue&type=script&lang=ts&setup=true"

import "./Message.vue?vue&type=style&index=0&id=5c3a013b&lang=scss"

const __exports__ = script;

export default __exports__